var COMPONENT_NAME = 'Slider';
export var baseCheckSliderMinMaxProps = function (_a) {
    var min = _a.min, max = _a.max, _b = _a.componentName, componentName = _b === void 0 ? COMPONENT_NAME : _b;
    if (max <= min) {
        throw new Error(componentName + " error: the argument \"max\" must be greater than \"min\".");
    }
};
export var checkSliderMinMaxProps = function (_a) {
    var min = _a.min, max = _a.max;
    baseCheckSliderMinMaxProps({ min: min, max: max });
    if (max > 100) {
        throw new Error(COMPONENT_NAME + " error: the argument \"max\" must be smaller than or equal to 100.");
    }
    if (min < 0) {
        throw new Error(COMPONENT_NAME + " error: the argument \"min\" must be greater than or equal to 0.");
    }
};
export var checkSliderStepProperty = function (_a) {
    var min = _a.min, max = _a.max, step = _a.step, _b = _a.componentName, componentName = _b === void 0 ? COMPONENT_NAME : _b;
    if (max % step !== 0) {
        throw new Error(componentName + " error: the argument \"max\" must be a multiple of step.");
    }
    if (min % step !== 0) {
        throw new Error(componentName + " error: the argument \"min\" must be a multiple of step.");
    }
};
export var getLimitedValue = function (_a) {
    var min = _a.min, value = _a.value, max = _a.max;
    return Math.max(Math.min(value, max), min);
};
export var getNewPositionThumb = function (oldValue, trackWidth, clientXDelta, max, min) { return Math.max(Math.min(oldValue + (clientXDelta / trackWidth) * 100, max), min); };
export var getValueFromPositionThumb = function (oldValue, newPosition, step, direction) {
    var valueDelta = Math.abs(newPosition - oldValue);
    var residue = valueDelta % step;
    if (step / 2 < residue) {
        return newPosition + direction * (step - residue);
    }
    else {
        return newPosition - direction * residue;
    }
};
//# sourceMappingURL=helpers.js.map